module.exports = __webpack_public_path__ + "static/media/snack.127c35d2.png";